import React from 'react';
import { ListChecks, CheckCircle2, XCircle, Circle, Ban, Percent, Scale } from 'lucide-react';

const CARDS = [
  { key: 'demandees', label: 'Demandées', icon: ListChecks, cls: 'border-gray-200 text-gray-800' },
  { key: 'terminees', label: 'Terminées', icon: CheckCircle2, cls: 'border-emerald-300 text-emerald-700' },
  { key: 'non_realisees', label: 'Non réalisées', icon: XCircle, cls: 'border-red-300 text-red-700' },
  { key: 'ouvertes', label: 'Encore ouvertes', icon: Circle, cls: 'border-blue-200 text-blue-700' },
  { key: 'annulees', label: 'Annulées', icon: Ban, cls: 'border-gray-200 text-gray-500' },
];

const ReportSummary = ({ summary, units }) => (
  <div className="space-y-3" data-testid="report-summary">
    <div className="grid grid-cols-3 md:grid-cols-6 gap-2">
      {CARDS.map(c => (
        <div key={c.key} className={`bg-white border-2 rounded-2xl p-2.5 md:p-3 min-h-[64px] ${c.cls}`} data-testid={`report-total-${c.key}`}>
          <div className="flex items-center gap-1 text-[10px] md:text-xs font-bold uppercase tracking-wide"><c.icon size={12} />{c.label}</div>
          <div className="font-heading text-2xl font-bold" data-testid={`report-total-${c.key}-value`}>{summary[c.key]}</div>
        </div>
      ))}
      <div className="bg-neon-pink/10 border-2 border-neon-pink/30 rounded-2xl p-2.5 md:p-3 min-h-[64px] text-neon-pink" data-testid="report-total-taux">
        <div className="flex items-center gap-1 text-[10px] md:text-xs font-bold uppercase tracking-wide"><Percent size={12} />Taux réalisation</div>
        <div className="font-heading text-2xl font-bold" data-testid="report-total-taux-value">{summary.taux_realisation == null ? '—' : `${summary.taux_realisation} %`}</div>
      </div>
    </div>
    {units.length > 0 && (
      <div className="bg-white border border-gray-200 rounded-2xl p-3 flex flex-wrap items-center gap-x-5 gap-y-1 text-sm" data-testid="report-units">
        <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-gray-400"><Scale size={12} />Quantités par unité</span>
        {units.map(u => (
          <span key={u.unit} className="text-gray-700" data-testid={`report-unit-${u.unit}`}>
            <span className="font-semibold">{u.unit}</span> : {u.planned} demandé · <span className="text-emerald-700 font-semibold">{u.actual} produit</span>
          </span>
        ))}
        <span className="text-xs text-gray-400">Les unités différentes ne sont jamais additionnées.</span>
      </div>
    )}
  </div>
);

export default ReportSummary;
